<template>
  <div class="circletabbox">
    <ul class="circleul">
      <li :class="liindex==0 ? 'active' : '' " @click="gotourl(0)"><span>推荐</span></li>
      <li :class="liindex==1 ? 'active' : '' " @click="gotourl(1)"><span>关注</span></li>
      <li :class="liindex==2 ? 'active' : '' " @click="gotourl(2)"><span>最近访问</span></li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      liindex: 0
    };
  }, created () {

    this.changetabbar();

    this.onPath = this.$route.path;

  },
  methods: {

    gotourl: function (liindex) {

      switch (liindex) {
        case 0:
          this.$router.push({ name: "circlelist" });
          this.liindex = 0;
          break;
        case 1:
          this.$router.push({ name: "circlefollow" });
          this.liindex = 1;
          break;
        case 2:
          this.$router.push({ name: "circlevisit" });
          this.liindex = 2;
          break;
      }

    },
    changetabbar: function () {
      //判断当前的路由所在区域给
      this.onPath = this.$route.path;
      if (this.onPath == '/circlevisit') {

        this.liindex = 2

      } else if (this.onPath == '/circlefollow') {

        this.liindex = 1

      } else if (this.onPath == '/circlelist') {

        this.liindex = 0

      }

    }

  }
};
</script>

<style scoped>
.circletabbox .circleul {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #efefef;
  padding: 0 1.2rem;
  padding-top: 0.5rem;
}
.circletabbox .circleul li {
  font-size: 0.81rem;
  text-align: center;
  color: #666666;
  flex: 0 0 33.333%;
}
.circletabbox .circleul li span {
  padding: 0.5rem 0;
  display: inline-block;
}
.circletabbox .circleul li.active {
  color: #ffbd0a;
}
.circletabbox .circleul li.active span {
  border-bottom: 3px solid #ffbd0a;
}
</style>


// WEBPACK FOOTER //
// src/components/public/circletabbar.vue